
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton, AppSelect, AppFormRow } from '@/components';
import { useRfmMonetaryList } from '@/modules/rfm/monetary/model/list';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_RFM.MONETARY.INDEX,
    components: { AppTable, AppButton, AppSelect, AppFormRow, AppCard },
    setup() {
        const { list, total, fetchList, rfmGroupOptions, query, actions } = useRfmMonetaryList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Rfm Group', key: 'groupName' },
                { type: TableColumnType.Text, label: 'From Payment', key: 'fromPayment' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_RFM.MONETARY.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, rfmGroupOptions, query, ROUTE_NAME_RFM };
    }
});
